export const trans_5_1=[
  {
    id:1,
    english:'How much is it?',
    vietnamese:'Cái này bao nhiêu tiền?',
    user_message:''
  },
  {
    id:2,
    english:'Welcome to vietnam',
    vietnamese:'Chào mừng đến Việt Nam',
    user_message:''
  },
  {
    id:3,
    english:'I want to eat something',
    vietnamese:'Tôi muốn ăn thứ gì đó',
    user_message:''
  },
  {
    id:4,
    english:'We are going to the cinema at the moment',
    vietnamese:'Chúng tôi chuẩn bị đi xem phim',
    user_message:''
  }, 
]

export const trans_5_2=[
  {
    id:1,
    english:'How much is this shirt?',
    vietnamese:'Cái áo này bao nhiêu tiền?',
    user_message:''
  },
  {
    id:2,
    english:'How much is a bottle of beer?',
    vietnamese:'Bao nhiêu tiền 1 chai bia?',
    user_message:''
  },
  {
    id:3,
    english:'How much is a kilogram of apple?',
    vietnamese:'Một cân táo bao nhiêu tiền?',
    user_message:''
  },
  {
    id:4,
    english:'How much is that?',
    vietnamese:'Cái kia bao nhiêu tiền?',
    user_message:''
  },
]